import AuthorizationBox from './AuthorizationBox';

export default AuthorizationBox;
